import styled from "styled-components";

import { StyledCarouselScrollBarProps } from "./CarouselScrollBar.types";

export const StyledCarouselScrollBar = styled.input<StyledCarouselScrollBarProps>`
	display: block;
	position: absolute;
	width: 100%;
	top: 50%;
	transform: translateY(-50%);
	appearance: none;
	height: 4px;
	outline: none;
	transition: height 200ms ease-in-out;
	border-radius: ${({ theme }) => theme.radii.xxs};
	cursor: pointer;
	margin: 0;
	margin-right: -150px;

	:active::-webkit-slider-thumb {
		cursor: grabbing;
	}

	${({ theme, pageCount }) => {
		const COLOR_BG_LIGHT = theme.palette.hexForRole("bg_light");
		const COLOR_CTA_DEFAULT = theme.palette.hexForRole("cta_default");

		return {
			backgroundColor: COLOR_BG_LIGHT,
			"::-webkit-slider-thumb": {
				appearance: "none",
				width: `calc(100% / ${pageCount})`,
				height: "4px",
				backgroundColor: COLOR_CTA_DEFAULT,
				cursor: "grab",
				borderRadius: theme.radii.xxs,
				transition: "height 300ms ease-in-out",
			},
			"::-moz-range-thumb": {
				appearance: "none",
				width: `calc(100% / ${pageCount})`,
				height: "4px",
				backgroundColor: COLOR_CTA_DEFAULT,
				cursor: "grab",
				borderRadius: theme.radii.xxs,
				transition: "height 300ms ease-in-out",
			},
		};
	}}
`;
